import { DatePicker, Form, Input, Select } from 'antd';
import moment from 'moment';
import React, { PureComponent } from 'react';
import { API_DATE_FS } from './shared';

const VALID_STATES = ['NZ'];

export class NZNPCFormItems extends PureComponent {
  static slug = 'nznpc';

  constructor(props) {
    super(props);
    this.state = {};
  }

  static getSubmissionData(checkData, constituent) {
    return {
      identifier: checkData.identifier,
      ...(checkData.state && { state: checkData.state }),
      issued_by: checkData.issued_by,
      ...(checkData.attainment && { attainment: checkData.attainment.format(API_DATE_FS) }),
      ...checkData.expiry && { expiry: checkData.expiry.format(API_DATE_FS) },
      fullName: constituent.get('fullName'),
    };
  }

  disablePastDate = current => current && current < moment().endOf('day');

  disableAttainmentDate = current => {
    // Can not select days after today
    return current && current > moment().endOf('day');
  }
  
  render() {
    const { form, disabled, rules } = this.props;
    const { getFieldDecorator } = form;
    const { slug } = this.constructor;

    const ident = {
      label: 'Identifier',
      slug: `${slug}.identifier`,
    };
    const state = {
      label: 'State',
      slug: `${slug}.state`,
    };
    const issued_by = {
      label: 'Issued By',
      slug: `${slug}.issued_by`,
    };
    const attainment = {
      label: 'Attainment',
      slug: `${slug}.attainment`,
    };
    const expiry = {
      label: 'Expiry',
      slug: `${slug}.expiry`,
    };

    return (
      <>
        <Form.Item label={ident.label}>
          {getFieldDecorator(ident.slug, {
            rules: [
              {
                required: true,
                whitespace: true,
                message: `${ident.label} is required`,
              },
              ...(rules || []),
            ],
          })(<Input disabled={disabled} />)}
        </Form.Item>
        <Form.Item label={state.label}>
          {getFieldDecorator(state.slug, {
            rules: [
              ...(rules || []),
            ],
          })(
            <Select
              showSearch
              disabled={disabled}
              optionFilterProp="children"
              filterOption={(input, option) => option.props.children
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
              }
            >
              {VALID_STATES.map(member => (
                <Select.Option key={member} value={member}>
                  {member}
                </Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item label={issued_by.label}>
          {getFieldDecorator(issued_by.slug, {
            rules: [
              {
                required: true,
                whitespace: true,
                message: `${issued_by.label} is required`,
              },
              ...(rules || []),
            ],
          })(<Input disabled={disabled} />)}
        </Form.Item>
        <Form.Item label={attainment.label}>
          {getFieldDecorator(attainment.slug, {
            rules: [
              {
                required: true,
                message: `${attainment.label} is required`,
              },
              ...(rules || [])],
          })(
            <DatePicker
              format="DD-MM-YYYY"
              placeholder="DD-MM-YYYY"
              disabled={disabled}
              disabledDate={this.disableAttainmentDate}
            />,
          )}
        </Form.Item>
        <Form.Item label={expiry.label}>
          {getFieldDecorator(expiry.slug, {
            rules: [
              ...(rules || [])],
          })(
            <DatePicker
              format="DD-MM-YYYY"
              placeholder="DD-MM-YYYY"
              disabled={disabled}
              disabledDate={this.disablePastDate}
            />,
          )}
        </Form.Item>
      </>
    );
  }
}
